import api from "../api/flexapi";

export const LOAD_DASHBOARD_BEGIN_PP = "LOAD_DASHBOARD_BEGIN_PP";
export const LOAD_DASHBOARD_SUCCESS_PP = "LOAD_DASHBOARD_SUCCESS_PP";
export const LOAD_DASHBOARD_ERROR_PP = "LOAD_DASHBOARD_ERROR_PP";

export const GET_MESSAGE_BOARD_SUCCESS = "GET_MESSAGE_BOARD_SUCCESS";
export const GET_MESSAGE_BOARD_ERROR = "GET_MESSAGE_BOARD_ERROR";

export const GET_INSURANCE_ADS_BEGIN = "GET_INSURANCE_ADS_BEGIN";
export const GET_INSURANCE_ADS_SUCCESS = "GET_INSURANCE_ADS_SUCCESS";
export const GET_INSURANCE_ADS_ERROR = "GET_INSURANCE_ADS_ERROR";

export const GET_DASHBOARD_ACTIONS_PP_SUCCESS = "GET_DASHBOARD_ACTIONS_PP_SUCCESS";
export const GET_DASHBOARD_ACTIONS_PP_ERROR = "GET_DASHBOARD_ACTIONS_PP_ERROR";

export const getDashboardPP = () => dispatch => {
  dispatch({ type: LOAD_DASHBOARD_BEGIN_PP, payload: null });
  api
    .getDashboardPP()
    .then(response => {
      dispatch({ type: LOAD_DASHBOARD_SUCCESS_PP, payload: response.body });
    })
    .catch(err => {
      dispatch({
        type: LOAD_DASHBOARD_ERROR_PP,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const getMessageBoard = () => dispatch => {
  api
    .getMessageBoard()
    .then(response => {
      dispatch({ type: GET_MESSAGE_BOARD_SUCCESS, payload: response.body });
    })
    .catch(err => {
      dispatch({
        type: GET_MESSAGE_BOARD_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const getInsuranceAds = () => dispatch => {
  dispatch({ type: GET_INSURANCE_ADS_BEGIN, payload: null });
  api
    .getInsuranceAds()
    .then(response => {
      dispatch({ type: GET_INSURANCE_ADS_SUCCESS, payload: response.body });
    })
    .catch(err => {
      dispatch({
        type: GET_INSURANCE_ADS_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const getDashboardActions = () => dispatch => {
  api
    .getDashboardActions()
    .then(response => {
      dispatch({ type: GET_DASHBOARD_ACTIONS_PP_SUCCESS, payload: response.body });
    })
    .catch(err => {
      dispatch({
        type: GET_DASHBOARD_ACTIONS_PP_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};



// WEBPACK FOOTER //
// ./actions/dashboardActionsPP.js